import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { store } from './app/store';
import { initializeAuth } from './app/slices/authSlice';
import AppRoutes from './app/routes';
import ToastContainer from './components/ToastContainer';
import TestKeyBanner from './components/TestKeyBanner';
import { trackUsage } from './lib/telemetry';
import { markBoot } from './debug/BootSentinel';
import { DebugOverlay } from './debug/DebugOverlay';
import './index.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  useEffect(() => {
    // Initialize authentication state
    store.dispatch(initializeAuth());
    markBoot('APP_MOUNT');
  }, []);

  useEffect(() => {
    // Track device info once per session
    trackUsage('usage_device').catch(console.warn);
  }, []);

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <div className="App">
            <TestKeyBanner />
            <AppRoutes />
            <ToastContainer />
            <DebugOverlay />
            {/* Inline panels handle all flows; onboarding uses a dedicated page */}
          </div>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
